import * as React from 'react';
import { AllHTMLAttributes } from 'react';
import { YouTubeVideo } from '../atoms/YouTubeVideo';
import { TrackSchema } from '../../../types/schema';
import { style } from 'typestyle';
import { px } from 'csx';
import { rebrand } from '../../../theme/color';
import { borderRadius } from '../../../theme/border';
import { spacing } from '../../../theme/spacing';
import { YouTubePlayIcon } from '../atoms/icons/brands/YouTubePlayIcon';
import { center, flexRoot } from 'csstips';
import { mixinTextEllipsis } from '../../../theme/mixin';
import { Link } from '../atoms/Link';
import { TrackLine } from './TrackLine';

const styles = {
  wrapper: style({
    backgroundColor: rebrand.neutralOnDark[10].toString(),
    borderRadius: borderRadius.MEDIUM,
    padding: spacing.DEFAULT,
    overflow: 'hidden',
  }),
  channelInfo: style(flexRoot, center, {
    color: rebrand.neutralOnLight[70].toString(),
    fontSize: px(12),
    gap: spacing.XXSMALL,
    marginBottom: spacing.XXSMALL,
    $nest: {
      '&:hover span': {
        textDecoration: 'underline',
      },
    },
  }),
  videoTitle: style(mixinTextEllipsis, {
    display: 'block',
    fontWeight: 700,
    margin: `0 0 ${spacing.DEFAULT}`,
    $nest: {
      '& a': {
        $nest: {
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
  }),
  badgePadding: style({
    padding: '12px 16px',
  }),
  trackline: style({
    marginTop: spacing.DEFAULT,
    borderRadius: borderRadius.SMALL,
    borderBottom: 0,
  }),
};

interface VideoProps {
  youtube_video_id: string;
  youtube_video_track_timestamp: number;
  video_title: string;
  track: TrackSchema;
  youtube_channel: {
    id: string;
    name: string;
  };
}

export type YouTubeVideoTrackTileProps = Pick<AllHTMLAttributes<HTMLDivElement>, 'onMouseEnter' | 'onMouseLeave'> & {
  video: VideoProps;
};

export const YouTubeVideoTrackTile: React.FC<YouTubeVideoTrackTileProps> = ({
  video: { youtube_video_id, youtube_video_track_timestamp, track, video_title, youtube_channel },
  ...eventHandlers
}) => (
  <div className={styles.wrapper} {...eventHandlers}>
    <Link className={styles.channelInfo} href={`https://www.youtube.com/channel/${youtube_channel.id}`} target="_blank">
      <YouTubePlayIcon />
      <span>{youtube_channel.name}</span>
    </Link>

    <p className={styles.videoTitle}>
      <Link
        href={`https://www.youtube.com/watch?v=${youtube_video_id}${youtube_video_track_timestamp}`}
        target="_blank"
      >
        {video_title}
      </Link>
    </p>

    <YouTubeVideo id={youtube_video_id} timestamp={youtube_video_track_timestamp} />
    <TrackLine track={track} className={styles.trackline} />
  </div>
);
